<script lang="ts">
  import { Col, Form, FormGroup, Input, Label, Row } from "sveltestrap";
  import { BirthDate, PersonalDetails } from "../../../../utils/Constant/Constant";
  import {applyformdata,formdata,daydata,yeardata} from "../../../../Data/Miscellaneous/CardView"
  import YourExperience from "./YourExperience.svelte";
  import UploadYourFiles from "./UploadYourFiles.svelte";
  import YourEducationForm from "./YourEducationForm.svelte";
</script>
<div class="job-description">
  <h6 class="mb-0">{PersonalDetails} </h6>
  <Form class="theme-form">
      {#each applyformdata as applyItem}
        <Row>
          <Col>
            <FormGroup>
              <Label for={applyItem.id}>{applyItem.label}<span class="font-danger">*</span></Label>
              <Input id={applyItem.id} type={applyItem.type} placeholder={applyItem.place} />
            </FormGroup>
          </Col>
        </Row>
      {/each}
    <Row>
      <Col sm="4">
        <FormGroup>
          <Label>{BirthDate}</Label>
          <Col sm="12">
            <Input type="select" name="select" id="exampleSelect" value="January">
                {#each formdata as monthItem}
                    <option >{monthItem}</option>
                {/each}=
            </Input>
          </Col>
        </FormGroup>
      </Col>
      <Col sm="4">
        <FormGroup>
          <div class="col-form-label m-t-5">
            <Col sm="12">
              <Input type="select" class="js-example-basic-single" value="1">
                {#each daydata as dayItem}
                  <option >{dayItem}</option>
                {/each}
              </Input>
            </Col>
          </div>
        </FormGroup>
      </Col>
      <Col sm="4">
        <FormGroup>
          <div class="col-form-label m-t-5">
            <Input type="select" value="1985" class="js-example-basic-single col-sm-12">
              {#each yeardata as yearItem}
                <option>{yearItem}</option>
              {/each}
            </Input>
          </div>
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <FormGroup>
          <Label for="exampleFormControlInput4">{'Phone Number:'}</Label>
          <Input id="exampleFormControlInput4" type="email" placeholder="Enter Phone no." />
        </FormGroup>
      </Col>
    </Row>
  </Form>
  <YourEducationForm />
  <YourExperience />
  <UploadYourFiles />
</div>